import { render } from "./HBEPos.vue?vue&type=template&id=bb179ffc&scoped=true"
import script from "./HBEPos.vue?vue&type=script&lang=js"
export * from "./HBEPos.vue?vue&type=script&lang=js"

import "./HBEPos.vue?vue&type=style&index=0&id=bb179ffc&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb179ffc"]])

export default __exports__